import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-0f10fd36"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "sonlist"
};
const _hoisted_2 = {
  class: "top"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 播放全部");

const _hoisted_4 = {
  class: "collect"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "+", -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  const _component_SongList = _resolveComponent("SongList");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_icon, {
    name: "play-circle-o",
    size: "25"
  }), _createElementVNode("p", null, [_hoisted_3, _createElementVNode("span", null, "(共" + _toDisplayString($props.songList.length) + "首)", 1)]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("span", null, "收藏(" + _toDisplayString($props.subscribedCount) + ")", 1)])]), _createVNode(_component_SongList, {
    songList: $props.songList
  }, null, 8, ["songList"])]);
}